<template>
  <div id="shared-common">
    <KeepAlive>
      <Suspense>
        <RootComponent />
      </Suspense>
    </KeepAlive>
  </div>

  <ModalContainer />
  <LoadingPanel />
</template>

<script setup lang="ts">
import "bootstrap5";
import ModalContainer from "./ModalContainer.vue";
import LoadingPanel from "./LoadingPanel.vue";
import { onErrorCaptured, onMounted, ref } from "vue";
import {
  showUIError,
  ErrorFactory,
  AppError,
  useErrorNotifier,
  useErrorConsumer,
} from "../services/errorHandling";
import { ApiError, HttpError } from "../services/http";
import { useAuthentication } from "../services/auth/authentication/authentication-service-impl";
import RootComponent from "@/components/RootComponent.vue";
import { useRouter } from "../services/routing-services";
import { toastError } from "../services/notification-service";

const errorConsumer = useErrorConsumer();
errorConsumer.handleError(handleNotifiedError);

function handleNotifiedError(error: Error) {
  const appError = ErrorFactory.fromError(error);
  const isHandled = appError.handled;

  if (import.meta.env.VITE_IS_DEBUG === "true") {
    if (localStorage.getItem("breakOnError") === "true") {
      
    }

    if (localStorage.getItem("omitErrorLogging") !== "true") {
      console.error(
        "Error capturado en root-app-component",
        JSON.parse(appError.toJson())
      );
    }
  } else {
    console.error(
      "Error capturado en root-app-component",
      JSON.parse(appError.toJson())
    );
  }

  if (!isHandled) {
    if (
      appError instanceof ApiError &&
      appError.innerError instanceof HttpError
    ) {
      if (appError.innerError.statusCode === 401) {
        useAuthentication().clearLoginState();
        useRouter().replace({ name: "home" });
        toastError("Su sesión ha caducado");
        return true;
      }
    }

    showUIError(appError);
  }

  return false;
}

onErrorCaptured((error: Error) => {
  const appError = ErrorFactory.fromError(error);
  const notifier = useErrorNotifier();
  notifier.notifyError(appError);
  return false;
});
</script>
